import React, { useState } from 'react';
import { Play } from 'lucide-react';

const YT_PATTERN = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([a-zA-Z0-9_-]{11})/;
const extractYouTubeId = (url) => url.match(YT_PATTERN)?.[1] || null;

function YouTubeVideo({ ytId, title, playing, onPlay }) {
  if (playing) {
    return (
      <div className="aspect-video rounded-lg overflow-hidden shadow-card-lift">
        <iframe
          src={`https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0`}
          title={title}
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <button onClick={onPlay} className="w-full aspect-video rounded-lg overflow-hidden shadow-card-lift relative group cursor-pointer">
      <img src={`https://img.youtube.com/vi/${ytId}/hqdefault.jpg`} alt={title} width={480} height={360} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
      <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
        <div className="w-16 h-16 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
          <Play size={28} className="text-saffron ml-1" fill="currentColor" />
        </div>
      </div>
    </button>
  );
}

function FileVideo({ url }) {
  return (
    <div className="aspect-video rounded-lg overflow-hidden shadow-card-lift">
      <video controls className="w-full h-full object-cover" preload="metadata">
        <source src={url} />
      </video>
    </div>
  );
}

export default function VideoSection({ videos, productName }) {
  const [activeVideo, setActiveVideo] = useState(null);
  if (videos.length === 0) return null;
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8" data-testid="product-videos">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display text-2xl font-bold text-earth-dark mb-8">Product Videos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((url, i) => {
            const ytId = extractYouTubeId(url);
            return (
              <div key={url} className="group" data-testid={`product-video-${i}`}>
                {ytId
                  ? <YouTubeVideo ytId={ytId} title={`${productName} Video ${i + 1}`} playing={activeVideo === url} onPlay={() => setActiveVideo(url)} />
                  : <FileVideo url={url} />}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
